import { useEffect, useState } from "react";
import api from "../../services/api.tsx";
import OrderStatus from "../../Entities/Enums/OrderStatus.tsx";
import { useError } from "../../contexts/ErrorContext.tsx";
import ConfirmModal from "../../components/ConfirmModal.tsx";

const OrderManagementPage = () => {
  const [orders, setOrders] = useState([]);
  const { setError } = useError();
  const [confirmModal, setConfirmModal] = useState<{ show: boolean; orderId?: string }>({ show: false });

  useEffect(() => {
    // Fetch orders from backend
    const fetchOrders = async () => {
      try {
        const token = localStorage.getItem("access_token");
        const res = await api.get("/api/order/all-orders", {
          headers: { Authorization: `Bearer ${token}` },
        });
        setOrders(res.data);
      } catch (err) {
        setError(err.response?.data?.Message || "Bir hata oluştu.");
      }
    };
    fetchOrders();
  }, [setError]);

  const getStatusBadge = (status: string) => {
    const statusText = OrderStatus[status as keyof typeof OrderStatus]; // Map numeric status to string
    const statusColors: Record<string, string> = {
      Pending: "bg-yellow-500",
      Confirmed: "bg-green-500",
      Cancelled: "bg-red-500",
      Abandoned: "bg-gray-500",
    };
    return (
      <span
        className={`px-2 py-1 text-black text-sm rounded ${statusColors[statusText] || "bg-gray-400"}`}>
        {statusText}
      </span>
    );
  };

  // CANCEL ORDER
  const handleCancelOrder = (id: string) => {
    setConfirmModal({ show: true, orderId: id });
  };

  const confirmCancel = async () => {
    if (!confirmModal.orderId) return;
    try {
      const token = localStorage.getItem("access_token");
      await api.post(`/api/order/${confirmModal.orderId}/cancel`, {}, {
        headers: { Authorization: `Bearer ${token}` },
      });
      // Refresh orders after cancel
      const res = await api.get("/api/order/all-orders", {
        headers: { Authorization: `Bearer ${token}` },
      });
      setOrders(res.data);
    } catch (err) {
      setError(err.response?.data?.Message || "Sipariş iptal edilemedi.");
    } finally {
      setConfirmModal({ show: false });
    }
  };

  return (
    <div className="p-8">
      <h2 className="text-xl font-bold mb-3">Sipariş Yönetimi</h2>
      <table className="min-w-full bg-white border rounded text-sm">
        <thead>
          <tr className="bg-gray-100 text-left">
            <th className="py-1 px-2 border-b">Sipariş No</th>
            <th className="py-1 px-2 border-b">Kullanıcı Tipi</th>
            <th className="py-1 px-2 border-b">Kullanıcı</th>
            <th className="py-1 px-2 border-b">Email</th>
            <th className="py-1 px-2 border-b">Tarih</th>
            <th className="py-1 px-2 border-b">Toplam</th>
            <th className="py-1 px-2 border-b">Durum</th>
            <th className="py-1 px-2 border-b">İşlemler</th>
          </tr>
        </thead>
        <tbody>
          {orders.map((order: any) => (
            <tr key={order.id}>
              <td className="py-1 px-2 border-b">{order.id}</td>
              <td className="py-1 px-2 border-b">{order.user?.userType || "-"}</td>
              <td className="py-1 px-2 border-b">{order.user?.fullName || "-"}</td>
              <td className="py-1 px-2 border-b">{order.user?.email || "-"}</td>
              <td className="py-1 px-2 border-b">{order.createdAt?.slice(0, 10)}</td>
              <td className="py-1 px-2 border-b">{order.totalAmount} TL</td>
              <td className="px-1 py-2 border-b">{getStatusBadge(order.status)}</td>
              <td className="py-1 px-2 border-b">
                {/* Add view/edit/cancel buttons here */}
                <button className="text-blue-600 hover:underline mr-2">Detay</button>
                <button
                  className="text-red-600 hover:underline"
                  onClick={() => handleCancelOrder(order.id)}
                >
                  İptal
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <ConfirmModal
        show={confirmModal.show}
        title="Sipariş İptali"
        message="Bu siparişi iptal etmek istediğinize emin misiniz?"
        onConfirm={confirmCancel}
        onCancel={() => setConfirmModal({ show: false })}
        confirmText="Siparişi İptal Et"
        cancelText="Vazgeç"
      />
    </div>
  );
};

export default OrderManagementPage;